<template>
    <div class="attr">
        <span class="attr-label">{{ value.label }}</span>
        <div class="attr-cat-badges">
            <span class="attr-cat-badge">
                <i :class="value.value.icon || 'fal fa-tag'"></i>
                {{ value.value.label }}
            </span>
            <template v-if="value.value.subcategory">
                <i class="fal fa-chevron-right attr-cat-separator"></i>
                <span class="attr-cat-badge attr-cat-badge--sub">
                    {{ value.value.subcategory }}
                </span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategoryAttribute',
    props: ['value']
}
</script>

<style scoped>
.attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 6px;
}

.attr-cat-badges {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.attr-cat-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 14px;
    background: #eff6ff;
    color: #2563eb;
    border-radius: 20px;
    font-size: 0.82rem;
    font-weight: 600;
}

.attr-cat-badge i {
    font-size: 0.75rem;
}

.attr-cat-badge--sub {
    background: #f0fdfa;
    color: #0891B2;
}

.attr-cat-separator {
    font-size: 0.65rem;
    color: #cbd5e1;
}
</style>
